import { Stack, Text, useDisclosure, useToast } from '@chakra-ui/react'

import { ConfirmModal } from '@/components'
import { useDeleteFile, useGetDownloadFileUrl, useUpdateFileName } from '@/hooks/usePpzAuthorization'

import { PpzAuthorizationFile } from './PpzAuthorizationFile'

/**
 * Editable PpzAuthorizationFile component.
 * Can download, rename and delete file.
 */
export const EditablePpzAuthorizationFile = ({ ppzAuthorizationId, file }: { ppzAuthorizationId: number, file: string }) => {
  const downloadUrl = useGetDownloadFileUrl(ppzAuthorizationId, file)
  const { mutateAsync: renameFileAsync } = useUpdateFileName(ppzAuthorizationId, file)
  const { mutateAsync: deleteFileAsync } = useDeleteFile(ppzAuthorizationId, file)
  const toast = useToast()

  const updateFileName = (newFileName: string) => renameFileAsync({ newFileName })
    .then(() => {
      toast({
        title: 'Název souboru byl úspěšně změněn.',
        status: 'success'
      })
    })
    .catch(() => {
      toast({
        title: 'Chyba při změně názvu souboru.',
        status: 'error'
      })
    })

  const deleteFile = () => deleteFileAsync()
    .then(() => {
      toast({
        title: 'Soubor byl úspěšně smazán.',
        status: 'success'
      })
    })
    .catch(() => {
      toast({
        title: 'Chyba při mazání souboru.',
        status: 'error'
      })
    })

  const {
    isOpen: isDeleteConfirmOpen,
    onClose: onCloseDeleteConfirm,
    onOpen: onOpenDeleteConfirm,
  } = useDisclosure()
  return (
    <>
      <PpzAuthorizationFile key={file}
        name={file}
        downloadUrl={downloadUrl}
        onUpdateName={updateFileName}
        onDelete={onOpenDeleteConfirm} />
      <ConfirmModal
        title="Upozornění"
        isOpen={isDeleteConfirmOpen}
        onClose={(result) => result ? deleteFile().then(onCloseDeleteConfirm) : onCloseDeleteConfirm()}
        yesButtonContent="Ano"
        noButtonContent="Ne"
      >
        <Stack gap={6}>
          <Text>
            Opravdu si přejete smazat soubor {file}? Tato akce je nevratná.
          </Text>
        </Stack>
      </ConfirmModal>
    </>
  )
}